import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/sections/PageHeader';
import { FaqSection } from '../components/sections/FaqSection';
import { Button } from '../components/ui/button';
import { ArrowLeft, Leaf } from 'lucide-react';
import '../styles/home.css';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export default function ReflexologiePage() {
  return (
    <div className="home-container">
      <Helmet>
        <title>Réflexologie Plantaire Angoulême - Laura Body Réflexologue</title>
        <meta name="description" content="Séances de réflexologie plantaire à Angoulême avec Laura Body, réflexologue certifiée. Technique ancestrale pour rétablir l'équilibre naturel du corps, réduire le stress et améliorer votre bien-être. 65€ la séance." />
        <link rel="canonical" href="https://www.naturopathe-angouleme.fr/reflexologie-angouleme" />
      </Helmet>

      <PageHeader />

      <section className="page-hero-mini">
        <div className="section-container">
          <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l'accueil</Link>
          <h1 className="page-hero-title">Réflexologie Plantaire à Angoulême</h1>
          <p className="page-hero-description">
            Laura Body, réflexologue à Angoulême, vous propose des séances de réflexologie plantaire pour rétablir l'équilibre naturel de votre corps.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="section-container">
          <div className="page-content-block">
            <h2 className="section-title">Qu'est-ce que la réflexologie plantaire ?</h2>
            <p className="about-text">
              La réflexologie plantaire est une technique manuelle ancestrale qui consiste à stimuler des zones réflexes situées sous les pieds. Chaque zone correspond à un organe ou une partie du corps. En exerçant des pressions spécifiques, Laura Body, réflexologue à Angoulême, favorise la détente, stimule les capacités d'auto-régulation du corps et contribue à rétablir l'équilibre énergétique.
            </p>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Les bienfaits de la réflexologie plantaire</h3>
            <ul className="benefit-list page-benefit-list">
              <li><Leaf className="benefit-icon" /> Gestion du stress et de l'anxiété</li>
              <li><Leaf className="benefit-icon" /> Dynamisme de l'organisme</li>
              <li><Leaf className="benefit-icon" /> Harmonisation des fonctions vitales</li>
              <li><Leaf className="benefit-icon" /> Libération des tensions du dos</li>
              <li><Leaf className="benefit-icon" /> Amélioration de la circulation sanguine</li>
              <li><Leaf className="benefit-icon" /> Détente et relaxation profonde</li>
              <li><Leaf className="benefit-icon" /> Activation du système lymphatique</li>
              <li><Leaf className="benefit-icon" /> Soulagement des troubles du sommeil</li>
              <li><Leaf className="benefit-icon" /> Soulagement des migraines et maux de tête</li>
              <li><Leaf className="benefit-icon" /> Gestion des émotions</li>
            </ul>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Déroulement d'une séance de réflexologie à Angoulême</h3>
            <p className="about-text">
              Lors de votre séance de réflexologie plantaire chez Laura Body à Angoulême, vous êtes confortablement installé(e) dans un environnement apaisant. La séance dure environ 1 heure. Laura Body stimule les zones réflexes de vos pieds avec des techniques précises, adaptées à vos besoins. Chaque séance est unique et personnalisée.
            </p>

            <div className="page-price-block">
              <h3 className="benefit-section-title">Tarif séance de réflexologie plantaire</h3>
              <p className="page-price">65€ <span className="page-price-duration">/ 1 heure</span></p>
            </div>
          </div>
        </div>
      </section>

      <FaqSection />

      <section className="page-cta-section">
        <div className="section-container" style={{textAlign: 'center'}}>
          <h2 className="section-title">Réservez votre séance de réflexologie à Angoulême</h2>
          <p style={{marginBottom: '2rem', color: '#666'}}>Laura Body, réflexologue à Angoulême, vous accueille au 116 rue de Saintes</p>
          <a href={BOOKING_URL} target="_blank">
            <Button className="btn-primary-hero">Réserver maintenant</Button>
          </a>
        </div>
      </section>
    </div>
  );
}
